// libraries
import React from "react";

// components
import Events from "/react4xp/components/EventCard";
import News from "/react4xp/components/News";
import type { EventItem } from "/react4xp/components/EventCard";
import type { NewsArticle } from "/react4xp/components/News";
import Button from "/react4xp/components/Button";

// utils
import { isNonWhitespaceString } from "/lib/reactutils/utils";

// types
export type SearchResultItem =
  | { type: "event"; data: EventItem }
  | { type: "news"; data: NewsArticle };

export interface SearchResultsProps {
  items?: SearchResultItem[];
  nextPageUrl?: string;
  isLoading?: boolean;
  onLoadMore?: () => void;
  className?: string;
  loadMoreText?: string;
}

export default function SearchResults({
  items,
  nextPageUrl,
  isLoading,
  onLoadMore,
  className,
  loadMoreText,
}: SearchResultsProps) {
  const trimmedNextPageUrl = isNonWhitespaceString(nextPageUrl)
    ? (nextPageUrl as string).trim()
    : undefined;
  const loadMoreLabel = isNonWhitespaceString(loadMoreText)
    ? (loadMoreText as string).trim()
    : "Last flere";

  // Show button only if has trimmedNextPageUrl and onLoadMore handler
  const shouldRenderLoadMore = trimmedNextPageUrl && onLoadMore;

  return (
    <div className={className || "search-page__results"}>
      {/* Render interleaved results in the order they appear */}
      {items &&
        items.length > 0 &&
        items.map((item, index) => {
          if (item.type === "event") {
            return (
              <Events
                key={`event-${item.data.id || index}`}
                view="limited"
                events={[item.data]}
              />
            );
          } else if (item.type === "news") {
            return (
              <div key={`news-${item.data.id || index}`}>
                <News
                  view="one-left"
                  background="dark"
                  articles={[item.data]}
                />
              </div>
            );
          }
          return null;
        })}

      {shouldRenderLoadMore && (
        <div className="search-page__load-more">
          <Button
            onClick={onLoadMore}
            style="solid"
            color="primary"
            small
            loading={isLoading}
          >
            {loadMoreLabel}
          </Button>
        </div>
      )}
    </div>
  );
}
